<template>
  <div class="status-display">
    <img class="status-display__img" :src="imgPath" />
    <p v-html="showText" class="font--m-3 mt-2 mb-0"></p>
  </div>
</template>

<script>
export default {
  props: {
    display: {
      type: String,
      default: 'loading',
    },
    text: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      displays: [
        {
          name: 'loading',
          imgSrc: 'loading/loading--circle.gif',
          text: '주문목록을 열심히 <br />가져오고 있어요',
        },
        {
          name: 'waiting',
          imgSrc: 'display/timer-waiting.png',
          text: '주문 목록은 <span class="color--buynow font--m-3">19:00시</span>부터<br />확인이 가능합니다',
        },
        {
          name: 'not_scraped',
          imgSrc: 'display/paper-folder.png',
          text: '오늘의 주문목록을 <br />불러오기 전입니다',
        },
        {
          name: 'empty',
          imgSrc: 'display/paper-folder.png',
          text: '주문 목록이 <br />존재하지 않습니다.',
        },
        {
          name: 'closed',
          imgSrc: 'display/paper-folder.png',
          text: '오늘의 외상 신청이 <br />이미 완료되었습니다.',
        },
      ],
    }
  },
  computed: {
    selectedDisplay() {
      let result = this.displays[0]
      const temp = this.displays.filter((d) => d.name === this.display)
      if (temp.length > 0) {
        result = temp[0]
      }
      return result
    },
    showText() {
      let result = this.selectedDisplay.text
      if (this.text !== null) {
        result = this.text
      }
      return result
    },
    imgPath() {
      if (this.selectedDisplay.imgSrc.startsWith('http') === true) {
        return this.selectedDisplay.imgSrc
      } else {
        return require('@/assets/images/' + this.selectedDisplay.imgSrc)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.status-display {
  width: 100%;
  text-align: center;

  &__img {
    width: 150px;
    object-fit: contain;
  }
}
</style>
